import { defineStore } from 'pinia';
import api from '@/js/api.js';
import { useDonorStore } from '@/stores/DonorStore.js';

export const useModesStore = defineStore('modesStore', {
  state: () => ({
    modes: [],
    activeMode: null,
  }),
  actions: {
    async fetchModes() {
      if (!useDonorStore().hosts_id) {
        this.modes = [];
        this.activeMode = null;
        return null;
      }

      const response = await api.get(`/hosts/modes?hostId=${useDonorStore().hosts_id}`);

      const modes = response.data.data;

      this.activeMode = null;

      if (modes) {
        modes.sort(function (a, b) {
          return new Date(a.start.replace(' ', 'T')) - new Date(b.start.replace(' ', 'T'));
        });

        const now = new Date().getTime();
        for (let i = 0; i < modes.length; i++) {
          let item = modes[i];
          let startDate = new Date(item.start.replace(' ', 'T'));
          let endDate =
            item.noEnd == 1 || !item.end ? new Date(8640000000000000) : new Date(item.end.replace(' ', 'T'));
          startDate.toUTCString();
          if (now >= startDate.getTime() && now < endDate.getTime()) {
            this.activeMode = item;
            break;
          }
        }
        this.modes = modes;
      } else {
        this.modes = [];
      }
    },
  },
});
